'use client'

import { cn } from '@repo/ui/lib'
import { FilePlus2 } from 'lucide-react'
import { useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import { toast } from 'sonner'

export const DocDropzone = ({
  className,
  noClick,
  onDrop,
}: {
  className?: string
  noClick?: boolean
  onDrop: (acceptedFiles: File[]) => void
}) => {
  const { fileRejections, getInputProps, getRootProps, isDragActive } = useDropzone({
    accept: {
      'application/pdf': ['.pdf'],
      'image/bmp': ['.bmp'],
      'image/gif': ['.gif'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
      'image/svg+xml': ['.svg'],
      'image/webp': ['.webp'],
    },
    maxSize: 1024 * 1024,
    noClick,
    onDrop,
  })

  useEffect(() => {
    if (fileRejections.length > 0) {
      toast.error('File size too large. Max 1mb')
    }
  }, [fileRejections])

  return (
    <div
      className={cn(
        `border-1 h-full w-full cursor-pointer rounded-md border-dotted border-neutral-200 bg-gray-100 py-11 dark:border-0 dark:bg-[#262626]`,
        'flex items-center justify-center',
        className,
      )}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <div className="flex flex-col items-center justify-center text-neutral-400">
        <FilePlus2 size={24} />
        {isDragActive ? (
          <p>Drop the files here ...</p>
        ) : (
          <div className={'hidden lg:block'}>
            <p className={'text-center text-xs text-neutral-500 dark:text-[#e1e7ef]'}>
              Share files
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
